<template>
  <div
    class="d-flex flex-row justify-content-between align-items-center mb-2 position-relative"
  >
    <div v-if="disabled" class="position-absolute disable-hover"></div>
    <div
      v-for="option in options"
      :key="option.value"
      class="p-2 border rounded option-container"
      :class="
        value.value == option.value
          ? 'border-primary option-container-selected'
          : disabled
          ? ''
          : 'hover-border-primary hover-option-container'
      "
      :style="
        `width: ${100 / optionsPerRowWrapper - 2}%; 
  ${
    disabled || value.value != option.value
      ? ''
      : 'box-shadow: 0px 5px 7px -4px rgb(0 0 0 / 75%);'
  }`
      "
      @click="setSelected(option)"
    >
      <h5>
        <span
          class="badge px-4 py-2 w-100 text-white badge-fixed-size"
          :class="'badge-' + option.variant"
          >{{ option.label }}</span
        >
      </h5>
      <div class="d-flex justify-content-center align-items-center">
        <b-form-radio
          class="ml-3"
          name="radio-size"
          size="lg"
          v-model="value"
          :value="option"
          :disabled="disabled"
        ></b-form-radio>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusPicker",
  props: ["value", "options", "optionsPerRow", "disabled"],
  methods: {
    setSelected(newValue) {
      if (!this.disabled) this.$emit("input", newValue);
    }
  },
  computed: {
    optionsPerRowWrapper() {
      return this.optionsPerRow ? this.optionsPerRow : this.options.length;
    }
  }
};
</script>

<style scoped>
.option-container {
  opacity: 0.6;
}
.option-container-selected {
  opacity: 1 !important;
}
.hover-option-container:hover {
  cursor: pointer;
}
.disable-hover {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  opacity: 0.4;
  background-color: white;
}
</style>
